import React,{ lazy, Suspense } from 'react';

import { ApolloProvider } from "@apollo/client";

// import { ApolloProvider as ApolloProviderHooks } from "@apollo/client";
import ReactDOM from "react-dom";
import { BrowserRouter, Route } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { Provider as FolderStatusProvider } from "utils/hooks/folderStatus";

import App from "./App";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import client from "./shared/graphql";
import "./shared/locals/i18n";
import { StoreProvider } from "./shared/store";
import "antd/dist/antd.css";
import Spin from "./shared/components/Spin";

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback="{<Spin />}">
      <ApolloProvider client={client}>
        <BrowserRouter>
          <QueryParamProvider ReactRouterRoute={Route}>
            <StoreProvider>
              <FolderStatusProvider>
                <App />
              </FolderStatusProvider>
            </StoreProvider>
          </QueryParamProvider>
        </BrowserRouter>
      </ApolloProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
